import axios from 'axios'

export const getAllDistrict = (params) => {
  let remoteUrl = 'districts'

  return axios.get(remoteUrl, {params: params})
}



// WEBPACK FOOTER //
// ./src/api/district.js